export const colorLabel = ({
  code,
  name,
}: {
  code?: string | null;
  name?: string | null;
}) => `${code} ${name}`;
